// extracted by mini-css-extract-plugin
export default {"blockText":"notifications_blockText__5n4hj"};